
export const QuestionnaireEditorInitialValue = (questionnaire?: {
	schema: any;
	ui_schema: any;
}) => ({
	schema: questionnaire?.schema || {},
	ui_schema: questionnaire?.ui_schema || {},
})
